import { useEffect } from "react";

import { useSelector } from "react-redux";

import { checkPermissionsThunk } from "store/modules/mediaDevices/actions/thunks";
import { RootState, useAppDispatch } from "store/rootReducer";

export function useMediaPermissions() {
  const dispatch = useAppDispatch();
  const permissions = useSelector(
    (state: RootState) => state.mediaDevices.permissions,
  );

  useEffect(() => {
    dispatch(checkPermissionsThunk());

    const handleDeviceChange = () => {
      dispatch(checkPermissionsThunk());
    };

    navigator.mediaDevices.addEventListener("devicechange", handleDeviceChange);

    return () => {
      navigator.mediaDevices.removeEventListener(
        "devicechange",
        handleDeviceChange,
      );
    };
  }, [dispatch]);

  return permissions;
}
